import Subnav from './subnav';

const CLASSES = {
    hidden: 'hide',
    subnavOpen: 'header--background',
    scrolled: 'color',
    navColor: 'nav--color',
    burgerWhite: 'burger__bar--white',
};

const NAV_COLOR_DELAY = 300;
const SCROLL_DELTA = 5;     

class Header {
    constructor($el) {
        this.$el = $el;
        this.$nav = $el.find('[data-nav="el"]');
        this.$burger = $('.burger__bar'); 
        this.subnavs = [];

        this.lastScrollTop = 0;
        this.ticking = false;
        this.navColorTimeout = null;
        this.baseHeight = $el.innerHeight();
        this.navColorEnabled = this.$nav.hasClass(CLASSES.navColor);

        this.init();
    }

    init() {
        this.subnavs = this.$el
            .find('[data-subnav="el"]')
            .map((_, el) => new Subnav(
                $(el),
                this.$el,
                this.onSubnavOpen,
                this.onSubnavClose,
                this.closeAllSubnavs
            ))
            .get();

        $(window)
            .on('scroll.header', this.onScroll)
            .on('resize.header', this.onResize);
    }

    destroy() {
        $(window).off('.header');
        clearTimeout(this.navColorTimeout);
    }


    get isAnySubnavOpen() {
        return this.subnavs.some(subnav => subnav.isSubnavOpen);
    }

    get isHidden() {
        return this.$el.hasClass(CLASSES.hidden);
    }

    setNavColor(active) {
        if (!this.navColorEnabled) return;

        clearTimeout(this.navColorTimeout);

        const apply = () => {
            this.$nav.toggleClass(CLASSES.navColor, active);
            this.$burger.toggleClass(CLASSES.burgerWhite, active);
        };

        if (active) {
            apply();
        } else {
            this.navColorTimeout = setTimeout(apply, NAV_COLOR_DELAY);
        }
    }


    onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;

        requestAnimationFrame(() => {
            this.update();
            this.ticking = false;
        });
    };

    onResize = () => {
        if (!this.isAnySubnavOpen) {
            this.baseHeight = this.$el.innerHeight();
        }
    };

    update() {
        const scrollTop = Math.max($(window).scrollTop(), 0);

        if (scrollTop === 0) {
            this.lastScrollTop = 0;
            this.showAtTop();
            return;
        }

        const delta = scrollTop - this.lastScrollTop;
        if (Math.abs(delta) < SCROLL_DELTA) return;

        this.lastScrollTop = scrollTop;

        if (delta > 0) {
            this.hide();
        } else {
            this.showScrolled();
        }
    }

    showAtTop() {
        this.$el.removeClass(`${CLASSES.hidden} ${CLASSES.scrolled}`);
        this.setNavColor(true);
    }

    hide() {
        this.$el
            .addClass(CLASSES.hidden)
            .removeClass(CLASSES.scrolled);
        this.setNavColor(false);
    }

    showScrolled() {
        this.$el.removeClass(CLASSES.hidden);

        if (!this.isAnySubnavOpen) {
            this.$el.addClass(CLASSES.scrolled);
        }
    }


    onSubnavOpen = () => {
        const openSubnav = this.subnavs.find(subnav => subnav.isSubnavOpen);
        if (!openSubnav) return;

        const $panel = openSubnav.$subnav || openSubnav.$el;

        this.$el
            .addClass(CLASSES.subnavOpen)
            .removeClass(CLASSES.scrolled)
            .css('height', this.baseHeight + $panel.outerHeight());
    };

    onSubnavClose = () => {
        if (this.isAnySubnavOpen) return;

        this.$el
            .removeClass(CLASSES.subnavOpen)
            .css('height', '');

        if (!this.isHidden && this.lastScrollTop > 0) {
            this.$el.addClass(CLASSES.scrolled);
        }
    };

    closeAllSubnavs = () => {
        this.subnavs.forEach(subnav => subnav.close());
    };
}

export default Header;